var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(630),
		__webpack_require__.e(3169)
	]).then(next);
};